import React from 'react';
import './segmentos.scss';

import engenharia from './icons/engenharia.png'
import topografia from './icons/topografia.png'
import geologia from './icons/geologia.png'
import facilities from './icons/facilities.png'
import perfuracao from './icons/perfuracao.png'
import armazem from './icons/armazem.png'
import mecanica from './icons/mecanico.png'
import construcao from './icons/construcao.png'
import telhado from './icons/telhado_solar.png'
import parque from './picture/parque.png'

export default function Services(){

  const images = [engenharia, topografia, geologia, facilities, mecanica, perfuracao, armazem, construcao, telhado, parque ];

  return(
    <>
      <section id="segmentos">
        <div className='container'>
          <div>
            <h1
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
                Conheça nossas áreas de atuação
            </h1>
          </div>
            
          <div className='segmentos'>
            <div className='box-services' 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <picture>
                <img src={images[0]} width={55} alt='Seculos Engenharia' />
              </picture>
              <h2>Engenharia</h2>
              <p>Do planejamento à execução, oferecemos soluções completas em engenharia civil para atender às necessidades específicas de cada projeto.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[1]} width={55} alt='Seculos Engenharia' />
                </picture>
              <h2>Topografia</h2>
              <p> Temos soluções precisas e eficientes em topografia para diversos projetos, desde construção civil a georreferenciamento ambiental, com equipe qualificada e equipamentos modernos.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[5]} width={55} alt='Seculos Engenharia Apoio a Gelogia' />
                </picture>
              <h2>Apoio à Geologia</h2>
              <p> Equipe qualificada e tecnologia avançada para realizar levantamentos topográficos, mapeamento geológico, avaliação de riscos geotécnicos, entre outros serviços essenciais.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[3]} width={55} alt='' />
                </picture>
              <h2>Facilities</h2>
              <p>Otimizando processos e aumentando a eficiência dos ambientes corporativos. Garantimos a excelência na gestão de serviços de limpeza predial e industrial, manutenção de áreas verdes, controle de pragas, segurança, entre outros.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[4]} width={55} alt=''/>
                </picture>
              <h2>Manutenção Mecânica</h2>
              <p> Serviço especializado na inspeção, diagnóstico, reparo e manutenção de máquinas e equipamentos mecânicos. Inclui manutenção preventiva, corretiva e preditiva, garantindo o pleno funcionamento, aumento da vida útil e eficiência operacional.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[6]} width={55} alt='Seculos Engenharia armazem/ferramentaria'/>
                </picture>
              <h2>Armazém/Ferramentaria</h2>
              <p>Serviço especializado na gestão, armazenamento e fornecimento de ferramentas, equipamentos e materiais, com foco em organização, controle de estoque, manutenção preventiva e corretiva, rastreamento e atendimento ágil.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[7]} width={55} alt='Seculos Engenharia armazem/ferramentaria'/>
                </picture>
              <h2>Construção e Manutenção Civil </h2>
              <p>A construção e manutenção civil envolve a execução de obras e o reparo de estruturas para garantir segurança e durabilidade. A construção abrange todas as etapas de obra, enquanto a manutenção cuida da conservação e reparos contínuos.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[8]} width={55} alt='Seculos Engenharia armazem/ferramentaria'/>
                </picture>
              <h2>Manutenção de Telhados</h2>
              <p>
              A manutenção de telhados consiste em inspeções, reparos e substituições de componentes para garantir a impermeabilidade e integridade estrutural. Inclui serviços como troca de telhas, vedação de fissuras e limpeza de calhas.</p>
            </div>
            <div className='box-services'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <picture>
                  <img src={images[9]} width={55} alt='Seculos Engenharia armazem/ferramentaria'/>
                </picture>
              <h2>Áreas Verdes</h2>
              <p>
                Com foco em sustentabilidade e bem-estar, o setor de Áreas Verdes da Séculos Engenharia é responsável pela implantação, revitalização e manutenção de jardins, paisagismo e espaços ambientais. O serviço alia técnica, cuidado e compromisso com a preservação, garantindo ambientes mais harmoniosos, funcionais e seguros para clientes e comunidades.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
    )
  }
